<p-table [value]="data" stripedRows [scrollable]="true" scrollHeight="300px">
  <ng-template #header>
      <tr>
          <th style="width: 30%">Name</th>
          <th style="width: 40%">Remaining Days from Probation Period</th>
          <th style="width: 30%">Last day of Probation Period</th>
      </tr>
  </ng-template>
  <ng-template #body let-employee>
      <tr>
          <td>{{employee | fullName}}</td>
          <td>{{today | dateCompute: 'add' : 'days' : employee.remainingDays | dateToTimeRemaining}}</td>
          <td>{{today | dateCompute: 'add' : 'days' : employee.remainingDays | date: 'dd-MM-yyyy'}}</td>
      </tr>
  </ng-template>
</p-table>
